import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

import './plugins/vuelidate';
import './plugins/vuecookies';
import './plugins/vue2filters';
import './plugins/axios/axios-config';
import './plugins/vue-the-mask';
import './plugins/gmaps';
import './plugins/moment';

import './components/vue-components';

import './styles/app.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
